export default "__VITE_ASSET__sM3fgRxY__"